import { render, staticRenderFns } from "./StandardShipping.vue?vue&type=template&id=c011cea2"
import script from "./StandardShipping.vue?vue&type=script&lang=ts"
export * from "./StandardShipping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports